export default "\n  <main>\n    <router-outlet> </router-outlet>\n  </main>";